import { render, staticRenderFns } from "./TariffsTable.vue?vue&type=template&id=43aa5849&"
import script from "./TariffsTable.vue?vue&type=script&lang=js&"
export * from "./TariffsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43aa5849')) {
      api.createRecord('43aa5849', component.options)
    } else {
      api.reload('43aa5849', component.options)
    }
    module.hot.accept("./TariffsTable.vue?vue&type=template&id=43aa5849&", function () {
      api.rerender('43aa5849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/TariffsTable.vue"
export default component.exports